export default "__VITE_ASSET__tDJIMNex__"